/**
 * Theme JS building
 */
import './modernizr';
import 'modaal';
import 'slick-carousel';
import 'hypher/dist/jquery.hypher.js';
import 'hyphenation.en-gb';
import 'hyphenation.fi';
import 'hyphenation.sv';
import 'jquery-ui-dist/jquery-ui.js';
import 'wicg-inert/dist/inert.min.js';
import 'chart.js';
import 'chartjs-plugin-labels';

import Theme from './theme';

// Export the theme controller for global usage.
window.Theme = Theme;

// Require main style file here for concatenation.
import '../styles/main.scss';



// WEBPACK FOOTER //
// ./assets/scripts/main.js